import { Router } from '@angular/router';
import { user_local } from './../Models/local_user';
import { LoginService } from './../Services/login.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

username:string;
password:string;
error:boolean;
disable:boolean;

  constructor( private mylogin:LoginService, private myrouter:Router) { 
    
  
  }

  ngOnInit() {
  }
  //login 
  login(){
    //create form data 
    var form = new FormData();
    form.append('phone',this.username);
    form.append('password',this.password);
    console.log(this.username,this.password);
    //call login service 
    this.mylogin.login(form).subscribe(
      result=>{
        console.log(result)
        ///save user object
      
        
        //var user={user_id:result.user_id,user_name:result.user_name} 
       // this.u['user_id']= result.user_id;
        //this.u['user_name']=result.user_name;
        localStorage.setItem('token',result['token']);
        localStorage.setItem('userRole',result['user_role']);
        localStorage.setItem('user_id',result['user_id']);
        localStorage.setItem('user',JSON.stringify(result));
        if(result['user_id']=='uLHFM17DNN'){
       this.myrouter.navigate(['/home']);}
       if(result['user_role']=='editor'){
        this.myrouter.navigate(['/comment']);
       }
       else {
         this.myrouter.navigate(['allgames',result['user_id']])
       }
      //  console.log(this.u['user_id']);
        },
      error=>{
        this.error=true;
        console.log(error)}
    )
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/login/login.component.ts